import { theme } from 'antd'
import type React from 'react'

interface VolumeCircleProps {
  beforeVolume: number
  afterVolume: number
  tankVolume: number | undefined
  size?: number
}

export function VolumeCircle({
  beforeVolume,
  afterVolume,
  tankVolume = 8500,
  size = 32,
}: VolumeCircleProps): React.ReactElement {
  // Calculate percentages for visualization
  // Scale to 90% of the circle height to leave space at top
  const maxHeight = 90 // percentage of circle to use
  const minHeight = 10
  const beforePercentage = Math.max(minHeight, Math.min(maxHeight, (beforeVolume / tankVolume) * maxHeight))
  const afterPercentage = Math.max(minHeight, Math.min(maxHeight, (afterVolume / tankVolume) * maxHeight))
  const { token } = theme.useToken()

  return (
    <div
      style={{
        position: 'relative',
        width: size,
        height: size,
        borderRadius: '50%',
        border: `2px solid var(--gray-800)`,
        overflow: 'hidden',
        backgroundColor: 'var(--bg-1)',
      }}
    >
      <div
        style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: '105%',
          height: `${afterPercentage}%`,
          backgroundColor: 'var(--theme-color-1)',
          transition: 'height 0.3s ease',
        }}
      />
      <div
        style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          zIndex: 1,
          width: '100%',
          height: `${beforePercentage}%`,
          backgroundColor: token.green,
          transition: 'height 0.3s ease',
        }}
      />
    </div>
  )
}
